import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddEditInventoryLocationDialogComponent } from './add-edit-inventory-location-dialog.component';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { TextareaModule } from 'src/app/shared/components/textarea/textarea.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [AddEditInventoryLocationDialogComponent],
  imports: [
    CommonModule,
    DialogModule,
    InputModule,
    TextareaModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [AddEditInventoryLocationDialogComponent],
})
export class AddEditInventoryLocationDialogModule { }
